<template>
  <DialogFull
    :data="dialogSettings"
    v-if="dialogSettings.dialog"
    @close="close"
  >
    <template v-slot:dialog.body>
      <div class="container mt-10">
        <ApprovalChainTemplateForm
          ref="approvalChainTemplateForm"
          @onSubmit="createTemplate"
        />
      </div>
    </template>
    <template v-slot:dialog.action>
      <PrimaryButton @click.native="validateForm" :loading="isCreating">
        Create Approval Chain
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { APPROVAL_CHAIN_TEMPLATE_NAMESPACE } from "@/store/modules/organisations/organisation-approval-chain-templates";
import { CREATE_APPROVAL_CHAIN_TEMPLATE } from "@/store/modules/organisations/organisation-approval-chain-templates/actions";
import ApprovalChainTemplateForm from "@/views/settings/components/approval-chain-templates/components/ApprovalChainTemplateForm";

const { mapActions } = createNamespacedHelpers(
  APPROVAL_CHAIN_TEMPLATE_NAMESPACE
);
export default {
  props: {
    isOpen: Boolean
  },
  components: {
    PrimaryButton,
    DialogFull,
    ApprovalChainTemplateForm
  },
  data() {
    return {
      isCreating: false
    };
  },
  computed: {
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "New Approval Chain"
      };
    }
  },
  methods: {
    ...mapActions({
      createApprovalChain: CREATE_APPROVAL_CHAIN_TEMPLATE
    }),
    validateForm() {
      this.$refs.approvalChainTemplateForm.validateForm();
    },
    async createTemplate(approvalChainTemplate) {
      this.isCreating = true;
      await this.createApprovalChain(approvalChainTemplate);
      this.isCreating = false;
      this.close();
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
